<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col v-if="!loading" cols="12" md="9">
        <v-row>
          <h1>
            Hoşgeldin {{ leadsFirstName }}, seni aramızda görmek bizi çok
            heyecanlandırdı. Sen de kariyerine bizimle beraber başlamak için
            heyecanlı mısın?
          </h1>
        </v-row>
        <v-row justify="end">
          <router-link :to="{ name: 'register-form' }">
            <v-btn
              rounded
              class="pa-6 mt-5 text-bold"
              style="
                font-family: Georgia;
                font-size: 1.5rem;
                box-shadow: 2px 2px 4px #000000;
              "
              :x-large="buttonSize"
              color="primary"
              >Hadi Başlayalım !
            </v-btn>
          </router-link>
        </v-row>
      </v-col>
      <div
        v-else
        style="height: 250px"
        class="d-flex flex-column justify-content-center align-items-center"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          :size="70"
          width="7"
        ></v-progress-circular>
        <h3 class="mt-5"></h3>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { isEmptyObject } from "jquery";

export default {
  name: "LandingPage",
  data() {
    return {
      loading: true,
      user: {},
    };
  },
  created() {
    const interval = setInterval(() => {
      if (isEmptyObject(this.user)) {
        this.user = JSON.parse(localStorage.getItem("user"));
      } else {
        this.loading = false;
        clearInterval(interval);
      }
    }, 500);
  },
  computed: {
    buttonSize() {
      if (this.$vuetify.breakpoint.mobile) {
        return false;
      }
      return true;
    },
    leadsFirstName() {
      if (isEmptyObject(this.user)) return;
      const leadNameCount = this.user.name.split(" ");
      if (leadNameCount.length > 2) {
        return leadNameCount[0] + " " + leadNameCount[1];
      }
      return leadNameCount[0];
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: calc(1.5rem + 2vw);
  font-family: Georgia, "Times New Roman", Times, serif;
  color: whitesmoke;
  text-shadow: 2px 2px 4px #000000;
}
</style>
